// click.justwatch.com を止めるブラウザでだけ、ページ上の配信リンクを遷移先へ差し替える。
// SP の all.js は head で同期実行、PC は async なので、どちらも DOM の構築を待つ。
import JustWatchLink from './modules/justwatchLink';

function run() {
  JustWatchLink.init(document);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', run);
} else {
  run();
}
